import React, { Component } from 'react';
import { loadScripts } from '../../utils.js';
import './integration.css';

export default class IntegrationPage extends Component {

  componentDidMount() {
    // @TEMP original prototype tool was developed in jQuery
    const parent = document.getElementsByClassName('integration-page')[0];
    loadScripts([
      '/jquery/jquery.csvtojson.min.js',
      '/jquery/jquery.integration.js'
    ], parent, () => {
      const yearUUID = this.props.location.state && this.props.location.state.activeYear;
      // Pass an empty options object if year isn't selected so that we use the default FY19/20 value
      const options = yearUUID ? {yearUUID} : {};
      // jQuery is global via /public/index.html
      // eslint-disable-next-line
      window.$('.integration-page').mdIntegration(options);
    });
  }

  componentWillUnmount() {
    // @TODO beware of memory leaks...
  }

  render() {
    return (
      <div className='integration-page' />
    );
  }
}
